import * as _ from "lodash";
import config from "../config";

export const getResponseProperty = (root: any) =>
    (propName?: string) =>
    (arg: any) => _.get(arg, !!propName ? [root, propName] : root);

export const getProperty = getResponseProperty('data')

export const getData = getProperty();

export const getDataInBody = getProperty('Body');

const buildUrl = (apiRoot: string) => ({controller, path}: {controller: string, path: string}) =>
        `${apiRoot}/${controller}/${path}`;

const buildOrganizationUnitUrl = (apiRoot: string) =>
    ({organizationId, organizationUnitId, path}: {organizationId: number, organizationUnitId: number, path: string}) =>
        buildUrl(apiRoot)({
            controller: 'Organizations',
            path:`${organizationId}/organization-units/${organizationUnitId}/${path}`
        });

const buildOrganizationUrl = (apiRoot: string) => (path: string) => buildUrl(apiRoot)({controller: 'Organizations', path: path})

export const buildUrlFromConfig = buildOrganizationUnitUrl(config.api);
export const buildOrganizationUrlFromConfig = buildOrganizationUrl(config.api);
